import React from 'react';
import CreatableSelect from 'react-select/creatable';

import makeAnimated from 'react-select/animated';

const MultiSelect = ({closeMenuOnSelect, defaultValue, options, isMulti, label, isLoading, isSearchable, onSelect, onCreateOption, placeholder, selectedValues }) => {
    return (
        <div className="form-group">
			{label && (<label>{label}:</label>)}

            <CreatableSelect 
                onChange={onSelect}
                closeMenuOnSelect={closeMenuOnSelect}
                defaultValue={defaultValue}
                value={selectedValues}
                components={makeAnimated()}
                backspaceRemovesValue={false}
                isMulti={isMulti} 
                options={options} 
                aria-label={label} 
                isSearchable={isSearchable}
                placeholder={placeholder}
                isLoading={isLoading}
                classNamePrefix='createable-select'
                className="input-lg my-select" 
                onCreateOption={onCreateOption}
                styles={{
                    control: (baseStyles, state) => ({...baseStyles, boxShadow: state.isFocused ? '0 0 0 1px #235681' : '0', }),
                    menuList: (baseStyles) => ({ ...baseStyles, maxHeight: 500 }),
                }}
            />
		</div>
    );
}
 
export default MultiSelect;